module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4zze.318fd3ae.jpg";